import { useFeatureFlagVariantKey } from 'posthog-js/react'
import { HumanizerEditor } from './Humanizer/humanizer-editor'
import { FEATURE_FLAGS } from '../hooks/featureFlags'

const HumanizerPage = () => {
	return (
		<div className="flex flex-col gap-5 mt-12">
			<div className="flex flex-col z-10">
				<div className="text-3xl font-bold text-center">AI Humanizer</div>
				<div className="text-center text-gray-700">Transform AI-generated text into natural, undetectable content.</div>
				<div className="text-center text-gray-700">
					Powered by{' '}
					<a href="https://mask.ai" target="_blank" rel="noopener noreferrer" className="underline text-black">
						Mask AI
					</a>{' '}
				</div>
			</div>
			<div className="z-10 max-w-6xl w-full mx-auto pb-96 md:pb-24">
				<HumanizerEditor />
			</div>
			<div className="w-screen h-screen fixed bg-gradient-to-b from-white to-[#513bf6] top-0 opacity-15" />
		</div>
	)
}

export default HumanizerPage
